import { HostListener, Injectable } from '@angular/core';
import { API } from '../constant/api';
import { GameConstant } from '../constant/game.constant';
import { GameTypeConstant } from '../constant/game.type.constant';
import { GameLiveDealer } from '../models/game.livedealer';
import { GameRNG } from '../models/game.rng';
import { UtilService } from '../util/UtilService';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class LoadGameService {
  private videoTimeOut = null;
  public videoWindow;
  private historyNavigation = {};
  private colorPalette = false;
  queue;
  constructor(
    public utilService: UtilService,
    public userService: UserService
  ) {}

  get color(): boolean {
    return this.colorPalette;
  }

  set color(color: boolean) {
    this.colorPalette = color;
  }

  /**
   * Add the game name list
   * @method addItem
   * @ param id
   * @ param addNav
   */
  addItem = (id: string, addNav: string) => {
    this.historyNavigation[id] = addNav;
  };

  /**
   * Method get the game view list
   * @method getItemTotal
   * @return object
   */
  getItemTotal = (): object => {
    return this.historyNavigation;
  };

  removeOneItem = (removeId: number) => {
    delete this.historyNavigation[removeId];
  };
  /**
   * Method remove the game view list
   * @method removeItem
   * @ param removeId
   */
  removeItem = (removeId: number) => {
    const removeList: Array<string> = [];
    Object.keys(this.historyNavigation).forEach(function (key) {
      removeId < parseInt(key) ? removeList.push(key) : key;
    });
    // @ts-ignore
    removeList.forEach((e) => delete this.historyNavigation[e]);
  };

  removeAllItem = () => {
    this.historyNavigation = {};
  };

  loadGame = (
    gameName: string,
    gameFeature: string,
    betLimitId,
    seatAvailable: number,
    roomId?: string,
    newTable: number = 0,
    serverURL: string = '',
    rewriteURL: string = '',
    historyURL: string = '',
    tableId: string = ''
  ) => {
    let queryString = '';
    let uri = '';

    const gameType =
      gameFeature === GameTypeConstant.LIVEDEALER
        ? GameTypeConstant.LIVEDEALER
        : GameTypeConstant.RNG;

    if (gameFeature === GameTypeConstant.LIVEDEALER) {
      const gameObj: GameLiveDealer = new GameLiveDealer();

      // Get table ID with fallback logic
      const tableIdFromUrl = tableId;
      const tableIdFromConstant =
        GameConstant[(gameName + gameType + 'tableid').toUpperCase()];
      gameObj.tableId = tableIdFromConstant || tableIdFromUrl;

      gameObj.betlimitId = betLimitId;
      gameObj.gameTypeId =
        GameConstant[(gameName + gameType + 'TYPEID').toUpperCase()];
      gameObj.sessiontoken = this.userService.user.sessiontoken;
      gameObj.scheme = 'https';
      gameObj.serverName = window.location.hostname;
      gameObj.flylogin = this.userService.user.isFlyLogin;
      if (this.userService.user.fullscreen != undefined) {
        gameObj.fullscreen = this.userService.user.fullscreen;
      }
      if (this.userService.user.rchistoryurl != undefined) {
        gameObj.rchistoryurl = this.userService.user.rchistoryurl;
      }
      if (this.userService.user.rciframeurl != undefined) {
        gameObj.rciframeurl = this.userService.user.rciframeurl;
      }
      if (this.userService.user.rcinterval != undefined) {
        gameObj.rcinterval = this.userService.user.rcinterval;
      }
      if (this.userService.user.rcelapsed != undefined) {
        gameObj.rcelapsed = this.userService.user.rcelapsed;
      }
      if (this.userService.user.rcenable != undefined) {
        gameObj.rcenable = this.userService.user.rcenable;
      }

      gameObj.homeurl = this.utilService.getHomeUrlFromStorage();

      if (
        this.userService.user.reloadURL != undefined &&
        this.userService.user.reloadURL != null &&
        this.userService.user.reloadURL != ''
      ) {
        gameObj.reloadURL = this.userService.user.reloadURL;
      }
      gameObj.gameName =
        'live' + gameName + (this.utilService.isDesktopView ? '' : 'mobile');
      gameObj.lang = this.utilService.currentLanguage || 'en';
      gameObj.serverURL = this.utilService.rngServerURL || serverURL;
      gameObj.rewriteURL =
        rewriteURL ||
        '!signin/viewer/mobile/lobby' + this.utilService.rediretURLFromGame;
      gameObj.gdt = Date.now();
      gameObj.initialusertype = this.userService.user.initialusertype || 'PLAY';
      queryString = this.utilService.formatQueryString(gameObj);
    }

    if (gameFeature === GameTypeConstant.RNG) {
      const gameObj: GameRNG = new GameRNG();
      gameObj.gametypeId =
        GameConstant[(gameName + gameType + 'TYPEID').toUpperCase()];
      gameObj.betlimit = betLimitId;
      gameObj.gamename = gameName;
      gameObj.lang = this.utilService.currentLanguage || 'en';
      gameObj.serverURL = this.utilService.rngServerURL || serverURL;
      gameObj.rewriteURL =
        rewriteURL ||
        '!signin/viewer/mobile/lobby' + this.utilService.rediretURLFromGame;
      gameObj.historyURL =
        historyURL ||
        '!signin/viewer/mobile/lobby' + this.utilService.rediretURLFromGame;
      gameObj.newtable = newTable;
      gameObj.flylogin = this.userService.user.isFlyLogin;
      if (
        this.userService.user.reloadURL != undefined &&
        this.userService.user.reloadURL != null &&
        this.userService.user.reloadURL != ''
      ) {
        gameObj.reloadURL = this.userService.user.reloadURL;
      }
      gameObj.sessiontoken = this.userService.user.sessiontoken;
      gameObj.seat = seatAvailable;
      gameObj.gdt = Date.now();
      gameObj.initialusertype = this.userService.user.initialusertype;
      if (this.userService.user.fullscreen != undefined) {
        gameObj.fullscreen = this.userService.user.fullscreen;
      }
      if (this.userService.user.rchistoryurl != undefined) {
        gameObj.rchistoryurl = this.userService.user.rchistoryurl;
      }
      if (this.userService.user.rciframeurl != undefined) {
        gameObj.rciframeurl = this.userService.user.rciframeurl;
      }
      if (this.userService.user.rcinterval != undefined) {
        gameObj.rcinterval = this.userService.user.rcinterval;
      }
      if (this.userService.user.rcelapsed != undefined) {
        gameObj.rcelapsed = this.userService.user.rcelapsed;
      }
      if (this.userService.user.rcenable != undefined) {
        gameObj.rcenable = this.userService.user.rcenable;
      }

      gameObj.homeurl = this.utilService.getHomeUrlFromStorage();

      if (roomId) {
        gameObj.roomid = roomId;
      }

      console.log('gameObj-->', gameObj);
      queryString = this.utilService.formatQueryString(gameObj);
      //console.log("queryString [('GAME_' + gameFeature).toUpperCase()]",[('GAME_' + gameFeature).toUpperCase()],queryString)
    }
    if (gameFeature === GameTypeConstant.LIVEDEALER && gameName == 'fc21') {
      uri = API.GAME_LIVEDEALERNEW + queryString;
    } else {
      uri = API[('GAME_' + gameFeature).toUpperCase()] + queryString;
    }

    window.open(uri, '_self');
  };

  loadWebsite(data) {
    if (this[data]) {
      this[data]();
    }
  }

  openFullColorCards() {
    window.open(API.FULL_COLOR_CARDS, 'fullcolorcards', '_blank');
  }

  openFullColorGames() {
    window.open(API.FULL_COLOR_GAMES, 'fullcolorgames', '_blank');
  }

  openVideoTutorial() {
    window.open(
      API.FULL_COLOR_GAMES_YOUTUBE,
      'fullcolorvideotutorial',
      '_blank'
    );
  }

  /***
   *  Method to open tutorials in new window for mobile instead of Coming Soon Page.
   */
  openTutorial(gameName, index, currentLanguage) {
    const params: any = {
      game: gameName,
      currentLanguage: currentLanguage,
      index: index,
    };
    window.open(
      API.FULL_COLOR_GAMES_TUTORIAL +
        this.utilService.formatQueryString(params),
      'help',
      '_blank'
    );
  }

  loadAssets(manifest) {
    this.queue = new createjs.LoadQueue(false);
    this.queue.setMaxConnections(10);
    this.queue.on('complete', this.handleComplete);
    this.queue.loadManifest(manifest);
  }

  handleComplete = (e) => {
    //console.log('Load Complete');
  };
  @HostListener('window:beforeunload', ['$event'])
  closeOnrefresh(event) {
    console.log('popup-close on refresh', event);
    this.logout();
  }

  openVideo(lang: string, duration: number = 10) {
    // console.log(duration," popup-showVideo ", lang);
    if (!this.videoWindow || (this.videoWindow && this.videoWindow.closed)) {
      clearTimeout(this.videoTimeOut);
      this.videoTimeOut = setTimeout(() => {
        this.logout();
      }, duration * 60 * 1000);
      const storageAccessToken = sessionStorage.getItem('x-fcg-access-token');

      const videoURL =
        window.location.protocol +
          '//' +
          window.location.hostname +
          '/signin/viewer/mobile/game' +
          '?gamename=video&lang=' +
          lang +
          '&duration=' +
          duration +
          '&sessiontoken=' +
          storageAccessToken ||
        this.userService.user.sessiontoken + '&t=' + Date.now();
      this.videoWindow = window.open(
        videoURL,
        'video',
        'width=' +
          window.screen.availWidth +
          ',height=' +
          window.screen.availHeight
      );
    } else {
      this.videoWindow.focus();
    }
  }

  logout() {
    console.log('popup-logout');
    if (this.videoWindow && !this.videoWindow.closed) {
      if (this.videoTimeOut !== null) {
        clearTimeout(this.videoTimeOut);
      }
      this.videoWindow.close(); // to close
    }
  }
}
